import React, { useEffect } from 'react';
import styles from './curso_mayzamoreira_lashdesign.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5532998055394';
const INSTAGRAM_URL = 'https://www.instagram.com/mayzamoreira_lashdesign/';
const MAPS_URL = 'https://maps.app.goo.gl/qL368NV5VDUWpgpk7';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    'Olá, tudo bem? Vim pelo Instagram e gostaria de informações sobre o Curso Olhar de Diva.'
)}`;

const APRENDER = [
    'Teoria completa dos fios, curvaturas e técnicas',
    'Aplicação fio a fio, volume 3D, 5D e Fox Eyes',
    'Design personalizado para cada formato de olho',
    'Isolamento correto, biossegurança e higiene',
    'Atendimento profissional, precificação e marketing inicial',
    'E muito mais',
];

const INCLUSO = [
    'Apostila completa',
    'Material para uso em aula',
    'Certificado de conclusão',
    'Lanche incluso nos dois dias',
    'Suporte com Mayza Moreira durante o curso e fora do curso',
    'Material individual',
    'Brindes',
];

const Curso_mayzamoreira_lashdesign: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.curso_mayzamoreira_lashdesign}>
                <div className={styles.header}>
                    <Link to="/mayzamoreira_lashdesign" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Curso</h2>
                </div>

                <div className={styles.hero}>
                    <img
                        src={require('./src/3.png')}
                        alt="Curso Olhar de Diva — Extensão de Cílios para Iniciantes"
                        className={styles.heroImage}
                    />
                </div>

                <div className={styles.content}>
                    <section className={styles.section}>
                        <p className={styles.eyebrow}>Mayza Moreira | Lash & Brow Design</p>
                        <h1 className={styles.title}>Curso Olhar de Diva</h1>
                        <p className={styles.lead}>Extensão de cílios para iniciantes</p>
                        <p className={styles.paragraph}>
                            Você quer começar na área da beleza e transformar a vida (e o olhar) das suas clientes?
                            Venha aprender do zero com o Curso Olhar de Diva, desenvolvido especialmente para iniciantes
                            que desejam se destacar no universo da extensão de cílios.
                        </p>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>Informações do curso</h3>
                        <div className={styles.infoRow}>
                            <div>
                                <span className={styles.infoLabel}>Duração</span>
                                <span className={styles.infoValue}>2 dias intensivos</span>
                            </div>
                            <div>
                                <span className={styles.infoLabel}>Público</span>
                                <span className={styles.infoValue}>Iniciantes</span>
                            </div>
                        </div>

                        <div className={styles.priceRow}>
                            <div>
                                <span className={styles.infoLabel}>Valor individual</span>
                                <span className={styles.priceValue}>R$ 850,00</span>
                            </div>
                            <div>
                                <span className={styles.infoLabel}>Valor em dupla</span>
                                <span className={styles.priceDuo}>R$ 750,00</span>
                                <span className={styles.priceHint}>por pessoa</span>
                            </div>
                        </div>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>O que você vai aprender</h3>
                        <ul className={styles.list}>
                            {APRENDER.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>O que está incluso</h3>
                        <ul className={styles.list}>
                            {INCLUSO.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>Local</h3>
                        <address className={styles.address}>
                            <p>Rua Marechal Deodoro, 360</p>
                            <p>Galeria João Pedro Hallack</p>
                            <p className={styles.addressHint}>Entrada ao lado da O Boticário</p>
                            <p>1º andar — Sala 101</p>
                            <p className={styles.addressCity}>Juiz de Fora — MG</p>
                        </address>
                        <a
                            href={MAPS_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.mapsLink}
                        >
                            Abrir no Maps
                        </a>
                    </section>

                    <section className={styles.ctaSection}>
                        <p className={styles.ctaTitle}>Garanta sua vaga</p>
                        <p className={styles.ctaText}>
                            Comece sua jornada como lash design com segurança e qualidade.
                        </p>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.ctaButton}
                        >
                            Quero garantir minha vaga
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.instagramLink}
                        >
                            Instagram @mayzamoreira_lashdesign
                        </a>
                        <p className={styles.whatsappHint}>WhatsApp (32) 99805-5394</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Curso_mayzamoreira_lashdesign;
